export default __webpack_public_path__ + "media/images/top-adv/bg-top-adv-0092597c040978f22a05e741d52529b5.svg";